//TODO : Refactor after ai
import * as Sentry from "@sentry/react";
import {
  ForgotPasswordPage,
  LoginPage,
  RegisterPage,
  ResetPasswordPage,
  VerifyEmailPage,
} from "@features/auth";
import {
  BaustellePage,
  ObjektDetailPage,
  ObjektUebersichtPage,
} from "@pages/viacid";
import {
  AngebotPage,
  AppShell,
  AufnahmeListePage,
  AufnahmePage,
  AuftraegeListePage,
  AuftragPage,
  BaustelleListePage,
  BaustelleMobilPage,
  ChancenListePage,
  ChancePage,
  CockpitPage,
  DatenDetailPage,
  DatenListePage,
  DatenUebersichtPage,
  Kunde360Page,
  KundenListePage,
  PlanungPage,
} from "@pages/app";
import { Settings } from "@pages/Settings";
import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import { LayoutWrapper } from "./LayoutWrapper";
import { CUSTOM_SUB_FEATURES, MAIN_FEATURES } from "./constants";
import {
  ErrorRoutes,
  ProtectedRoute,
  PublicOnlyRoute,
  RouterErrorElement,
} from "./guards";

// Enables Sentry route-change performance spans; falls back to plain createBrowserRouter
// when Sentry is not initialised (VITE_SENTRY_DSN unset)
const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouter(createBrowserRouter);

export const router = sentryCreateBrowserRouter([
  {
    path: "/",
    errorElement: <RouterErrorElement />,
    children: [
      // Root route - redirect to home
      {
        index: true,
        element: <Navigate to="/app" replace />,
      },
      // Public routes (no layout, no auth required)
      {
        path: MAIN_FEATURES.Auth,
        element: (
          <PublicOnlyRoute>
            <LayoutWrapper showLayout={false}>
              <Outlet />
            </LayoutWrapper>
          </PublicOnlyRoute>
        ),
        children: [
          {
            path: CUSTOM_SUB_FEATURES.Login,
            element: <LoginPage />,
          },
          {
            path: CUSTOM_SUB_FEATURES.Register,
            element: <RegisterPage />,
          },
          {
            path: CUSTOM_SUB_FEATURES.ForgotPassword,
            element: <ForgotPasswordPage />,
          },
          {
            path: CUSTOM_SUB_FEATURES.ResetPassword,
            element: <ResetPasswordPage />,
          },
          {
            path: CUSTOM_SUB_FEATURES.VerifyEmail,
            element: <VerifyEmailPage />,
          },
        ],
      },
      // App v2 – eigene Shell in Viacid-CI (docs/viacid-app)
      {
        path: "app",
        element: (
          <ProtectedRoute>
            <AppShell>
              <ErrorRoutes>
                <Outlet />
              </ErrorRoutes>
            </AppShell>
          </ProtectedRoute>
        ),
        children: [
          { index: true, element: <CockpitPage /> },
          { path: "kunden", element: <KundenListePage /> },
          { path: "kunden/:id", element: <Kunde360Page /> },
          { path: "chancen", element: <ChancenListePage /> },
          { path: "chancen/:id", element: <ChancePage /> },
          { path: "angebote/:id", element: <AngebotPage /> },
          { path: "aufnahme", element: <AufnahmeListePage /> },
          { path: "aufnahme/:id", element: <AufnahmePage /> },
          { path: "planung", element: <PlanungPage /> },
          { path: "baustelle", element: <BaustelleListePage /> },
          { path: "baustelle/:id", element: <BaustelleMobilPage /> },
          { path: "auftraege", element: <AuftraegeListePage /> },
          { path: "auftraege/:id", element: <AuftragPage /> },
          { path: "daten", element: <DatenUebersichtPage /> },
          { path: "daten/:slug", element: <DatenListePage /> },
          { path: "daten/:slug/:id", element: <DatenDetailPage /> },
        ],
      },
      // Protected routes (with layout, auth required)
      {
        element: (
          <ProtectedRoute>
            <LayoutWrapper>
              <ErrorRoutes>
                <Outlet />
              </ErrorRoutes>
            </LayoutWrapper>
          </ProtectedRoute>
        ),
        children: [
          {
            path: MAIN_FEATURES.Home,
            // Variante B: nach der Anmeldung direkt ins Viacid-Cockpit
            element: <Navigate to="/app" replace />,
          },
          {
            path: MAIN_FEATURES.Baustelle,
            element: <BaustellePage />,
          },
          {
            path: `${MAIN_FEATURES.Objekte}/:slug`,
            element: <ObjektUebersichtPage />,
          },
          {
            path: `${MAIN_FEATURES.Objekte}/:slug/:id`,
            element: <ObjektDetailPage />,
          },
          {
            path: MAIN_FEATURES.Settings,
            element: <Settings />,
          },
        ],
      },
    ],
  },
]);
